<rask-header size="4" noPadding>{{ "trädslagsdata - beräknat uttag" | uppercase }}</rask-header>
<div class="d-flex">
  <rask-textmultiline
    label="nettoareal"
    class="ps-0"
    value="{{atgard.nettoareal ?? 0 | number: '1.2-2': 'sv'}} ha">
  </rask-textmultiline>

  <rask-input-number [useDecimalProcessor]="true"
    id="uttagM3FHa"
    label="uttag m3f/ha"
    inputGroupRight="m3f"
    (change)="onUttagChanged()"
    [(ngModel)]="model.uttagM3FubHa"
    [disabled]="readonly"
    [isDecimal]="false"
    [min]="0"
    [isNegative]="false">
  </rask-input-number>

  <rask-textmultiline
    label="total volym"
    class="ps-0"
    value="{{totalVolymM3f}} m3f">
  </rask-textmultiline>

  <div class="mt-5 mb-2 volume-separator"></div>

  @if (!m3skVisible) {
    <a
      href="javascript: void(0)"
      class="pt-5 ms-3"
      (click)="showM3sk()">
      Visa m3sk
    </a>
  }
  @if (m3skVisible) {
    <rask-textmultiline
      class="ps-0 ms-3"
      value="{{totalVolymM3sk}} m3sk"
      >
    </rask-textmultiline>
  }

</div>

<div class="mt-4">
  <rask-hot-doc
    [canEdit]="!readonly"
    [hotDoc]="hotDoc">
  </rask-hot-doc>
</div>

<div class="d-flex mt-2">
  <div>
    <rask-add-tradslag-button
      [readonly]="readonly"
      [selectedTradslag]="selectedTradslag"
    (tradslagAdded)="onTradslagAdded($event)"></rask-add-tradslag-button>
  </div>
</div>

<div class="row mt-2">
  <div class="col">
    <div class="d-flex">
      <rask-button color="primary" [disabled]="!showCalculate() || readonly" (click)="calculateSnabbkalkyl()"
      class="px-0 my-0">Beräkna</rask-button>

      <rask-virkeskop-validation-icon-popover
        class="px-2"
        entityType="tradslag"
        [entityGuid]="atgard.guid">
      </rask-virkeskop-validation-icon-popover>
    </div>
  </div>
</div>

<div class="row mt-2">
  <div class="col">
    <rask-label size="5" class="px-0">Senast beräknad: {{getBeraknadTid()}}</rask-label>
  </div>
</div>

<rask-tradslag-utbyte
  [utbyte]="$safeNavigationMigration(model?.utbyte)"
  [getProduktgruppVolym]="getProduktgruppVolym" [getProduktgruppVolymStamblock]="getProduktgruppVolymStamblock"
  [showInfo]="true">
</rask-tradslag-utbyte>